import { render, staticRenderFns } from "./PersonalPropertyPictures.vue?vue&type=template&id=653bbf8d"
import script from "./PersonalPropertyPictures.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyPictures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports